import { render, staticRenderFns } from "./PixelWrapper.vue?vue&type=template&id=435dae20&"
import script from "./PixelWrapper.vue?vue&type=script&lang=js&"
export * from "./PixelWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports